import { renderRootNodesContent } from "./RenderRootNodesContent";
import { renderNestedNodeContent } from "./RenderNestedNodeContent";

export function renderNodeContent(data: { [key: string]: any } | number | string, depth: number, path: string[]) {
  if (depth === 0) {
    return renderRootNodesContent(data, path);
  } else {
    return renderNestedNodeContent(data, path);
  }
}
